import { Component, inject, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LikutScanService } from '@services/likut-scan.service';
import { combineLatest, map, Subject, takeUntil } from 'rxjs';
import { ScanHistoryItem } from 'src/app/Interfaces/likut';
import { LikutService } from 'src/app/services/likut.service';

@Component({
	selector: 'app-likut-task-scan-history',
	templateUrl: `./likut-task-scan-history.component.html`,
	styles: [
		`
			.wrapper {
				direction: rtl;
				padding: 0 clamp(10px, 3vw, 30px);
			}

			table {
				border-collapse: collapse;
				width: 100%;
				text-align: center;
				& td {
					border: 1px solid #e0e0e0;
				}
			}
		`,
	],
})
export class LikutTaskScanHistoryComponent implements OnInit, OnDestroy {
	_likut = inject(LikutService);
	_likutScan = inject(LikutScanService);
	private dialogRef = inject(MatDialogRef<LikutTaskScanHistoryComponent>);

	constructor(@Inject(MAT_DIALOG_DATA) public data: ScanHistoryItem[]) {}

	destroy$ = new Subject<void>();

	// TODO instead of subscribing twice, calculate the values once in anyAddedInfo$
	anyEitur$ = this._likutScan.likutBarcodeScansDisplay$.pipe(map(scans => scans.some(scan => scan.eitur !== null)));
	anyTokef$ = this._likutScan.likutBarcodeScansDisplay$.pipe(map(scans => scans.some(scan => scan.tokef !== null)));

	anyAddedInfo$ = combineLatest([this.anyEitur$, this.anyTokef$]).pipe(map(([eitur, tokef]) => ({ eitur, tokef })));

	// TODO Instead of injecting, use a service to get the data, and then display it in the table
	ngOnInit() {
		this._likutScan.likutBarcodeScansDisplay$.pipe(takeUntil(this.destroy$)).subscribe(filter => {
			if (!filter?.length) {
				this.dialogRef.close();
			}
		});
	}

	onYesClick() {
		this.dialogRef.close();
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
